<template>
  <div v-if="$route.meta.isLoggedIn" class="h-full w-full">
    <navbar></navbar>
    <sidebar v-if="$route.name != 'CourseShow'" />
    <main class="mt-16" v-if="GET_USER && GET_USER.id">
      <router-view
        class="routerview transition-all bg-white-dark "
        style="height:calc(100vh - 64px)"
        :class="routerViewContentClasses"
      />
    </main>
  </div>
  <div v-else>
    <router-view />
  </div>
  <!-- <toast-message
        style="z-index: 1000001"
        class="fixed bottom-16 left-0 right-0 lg:bottom-0"
        :class="
            GET_IS_MODAL_ACTIVE
                ? 'bottom-0 lg:left-0'
                : GET_IS_SIDEBAR_ACTIVE
                ? 'bottom-16 lg:left-70px'
                : 'bottom-16 lg:left-0'
        "
    /> -->
  <loading-animation />
</template>
<script>
import { computed, defineComponent, watch } from "vue";
import { useStore } from "vuex";
import {
  STORE_TYPES,
  HELPER_TYPES,
  AUTH_TYPES,
  AUTH_USER_TYPES,
  LAST_VIDEOS_TYPES,
} from "./store/types";
import Navbar from "./components/layout/Navbar.vue";
import Sidebar from "./components/layout/Sidebar.vue";
import LoadingAnimation from "./components/layout/LoadingAnimation.vue";
// import ToastMessage from "./components/layout/ToastMessage.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  components: { Navbar, LoadingAnimation, Sidebar },
  setup() {
    const route = useRoute();
    const store = useStore();
    /**
     *  Computed
     */
    const routerViewContentClasses = computed(() => {
      if (route.name === "CourseShow") {
        return "routerview-full scrollbar overflow-auto ";
      } else if (route.name === "LecturerDashboard") {
        return "px-3 lg:px-10 xl::px-20 overflow-y-auto scrollbar";
      } else {
        return "px-3 lg:px-10 xl::px-20 overflow-hidden";
      }
    });

    const GET_IS_SIDEBAR_ACTIVE = computed(
      () =>
        store.getters[
          `${STORE_TYPES.HELPERS}/${HELPER_TYPES.GET_IS_SIDEBAR_ACTIVE}`
        ]
    );

    const GET_USER = computed(
      () =>
        store.getters[`${STORE_TYPES.AUTH_USER}/${AUTH_USER_TYPES.GET_USER}`]
    );
    const IS_LOGGED_IN = computed(
      () => store.getters[`${STORE_TYPES.AUTH}/${AUTH_TYPES.IS_LOGGED_IN}`]
    );
    function FETCH_USER() {
      if (IS_LOGGED_IN.value == "true") {
        store.dispatch(
          `${STORE_TYPES.AUTH_USER}/${AUTH_USER_TYPES.FETCH_USER}`
        );
      }
    }
    function FETCH_LAST_VIDEOS() {
      if (GET_USER.value && GET_USER.value.id) {
        store.dispatch(
          `${STORE_TYPES.LAST_VIDEOS}/${LAST_VIDEOS_TYPES.FETCH_LAST_VIDEOS}`
        );
      }
    }
    FETCH_USER();
    FETCH_LAST_VIDEOS();
    /**
     *  Watch
     */
    watch(
      () => IS_LOGGED_IN.value,
      () => {
        FETCH_USER();
      }
    );
    watch(
      () => GET_USER.value.id,
      () => {
        FETCH_LAST_VIDEOS();
      }
    );

    return {
      routerViewContentClasses,
      GET_IS_SIDEBAR_ACTIVE,
      GET_USER,
    };
  },
});
</script>
<style lang="scss" scoped>
.routerview {
  height: calc(100vh - 121px);
  &.routerview-full {
    height: calc(100vh - 65px);
  }
  width: 100vw;
  @screen md {
    height: calc(100vh - 65px);
    &:not(.routerview-full) {
      width: calc(100vw - 424px);
    }
  }
}
</style>
